import React from "react";
import "../count-icon.scss";
import "./files-count-icon.scss";
import { WedIcon } from "../../wed-icon/WedIcon";
import { WedIconFolderBlank } from "../../wed-icon/generated/WedIconSvg";

interface PropsInterface {
    count: number;
}

interface StateInterface {}

export default class FilesCountIcon extends React.Component<PropsInterface, StateInterface> {
    render() {
        const { count } = this.props;

        return (
            <div className="count-icon">
                <WedIcon icon={<WedIconFolderBlank />} />
                <span className="count-icon__content">{count}</span>
            </div>
        );
    }
}
